/**
 * Орган общественного управления
 */
import { ClassifierShort } from '@n3/ng-api-common';
import { BaseModel } from '@n3/ng-api-base-kit';

export class PublicAdministration extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public id: number; /*Идентификатор БД*/
    public form: ClassifierShort; /**/
    public foundation_cause: string; /*Основание для создания*/
    public foundation_date: string; /*Дата создания*/
    public liquidation_date: string; /*Дата ликвидации*/
    public powers: string; /*Полномочия*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.id = json.id || null;
        this.form = new ClassifierShort(json.form);
        this.foundation_cause = json.foundation_cause || null;
        this.foundation_date = json.foundation_date || null;
        this.liquidation_date = json.liquidation_date || null;
        this.powers = json.powers || null;
        this._isEmpty = this.isEmpty(this);
    }
}
